import { font, themedColor } from '@lemonade-hq/cdk';
import { rgba } from 'polished';
import styled, { css } from 'styled-components';

function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  content: '';\n  background: transparent url('https://lmnd-images.s3.amazonaws.com/footer-icn-sprite-new.png') no-repeat ",
        "px\n    ",
        "px;\n  background-size: 180px 127px;\n  position: absolute;\n  z-index: 1;\n  display: block;\n  overflow: hidden;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        ";\n  color: ",
        ";\n  text-transform: uppercase;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  transition: background-color 0.2s;\n\n  &:hover {\n    cursor: pointer;\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var icons = function(param) {
    var left = param.spriteLeft, top = param.spriteTop;
    return css(_templateObject(), left, top);
};
var SectionTitle = styled.h3(_templateObject1(), font("main", {
    fontSize: "1.2rem",
    lineHeight: "1.6rem",
    fontWeight: 700
}), themedColor("metal"));
var backgroundHoverProps = css(_templateObject2(), function(props) {
    return rgba(props.theme.colors.white, 0.05);
});

export { SectionTitle, backgroundHoverProps, icons };
